
import _template from "lodash/template"
import _memoize from "lodash/memoize"
import u from "umbrellajs"

const by_domid = _memoize((template_id) => {
  // just to pretend it is handlebars
  return _template(u(template_id).html(), {
    interpolate: /{{(.+?)}}/g,
  })
})

export default {
  by_domid,
}
